/* src/app/forms/produtos/mercadolivre/meli-item/meli-variation/meli-variation.component.scss */
.simpletable {
  width: 100%;
  max-width: 100%;
  overflow: auto;
  display: block;
  border-collapse: collapse;
  margin: 0px;
  height: 100%;
}
table {
  width: 100%;
}
thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: var(--tem-surface-2, #fafafa);
}
tr.example-detail-row {
  height: 0;
}
tr.example-element-row {
  cursor: pointer;
}
tr.example-element-row:not(.example-expanded-row):hover {
  background: var(--tem-surface-2, rgba(0, 0, 0, 0.03));
}
.example-element-row td {
  border-bottom-width: 0;
}
.example-detail-row > td {
  padding-top: 0;
  padding-bottom: 0;
}
.example-element-detail {
  overflow: hidden;
  display: block;
}
.carousel-cell {
  width: 200px;
}
.data-expanded {
  height: 100%;
}
.data-expanded .left {
  float: left;
  width: 50%;
}
.data-expanded .right {
  float: right;
  width: 50%;
}
/*# sourceMappingURL=meli-variation.component.css.map */
